jQuery(document).ready(function ($) {

    $(document).on('click', 'a.js-open-popup', function (e) {
  
      if ($(e.target).closest('.js-no-popup').length) {
        return;
      }
  
      e.preventDefault();
  
      var popupId = $(this).data('popup');
      var $popup = $('#' + popupId);
  
      if ($popup.length) {
        $popup.addClass('is-active');
        $('html').addClass('popup-open');
      }
    });
  
    $(document).on('click', '.js-close-popup', function (e) {
      e.preventDefault();
  
      var $popup = $(this).closest('.card_popup');
      $popup.removeClass('is-active');
      $('html').removeClass('popup-open');
    });
  
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        $('.card_popup.is-active').removeClass('is-active');
        $('html').removeClass('popup-open');
      }
    });
  
});
  